import { createContext, useContext } from 'react';
import UserStore from './UserStore';

interface Store {
    commonStore: UserStore;
}

export const store: Store = {
    commonStore: new UserStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}
